module.exports = __webpack_public_path__ + "img/me.1d8b8fb6.jpg";